<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.notaVersao"
        ref="RkmDataTable"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                v-if="authorize('cadastro-nota-versao-update')"
                :to="{name: 'cadastro-nota-versao-edit', params: {id: item.nota_versao_id}}"
                color="primary"
                small
                title="Editar"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                v-if="authorize('cadastro-nota-versao-destroy')"
                @click="handleDestroy(item)"
                color="danger"
                small
                title="Excluir"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {authorization, error, notification} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {key: 'sistema_nome', label: 'Sistema', name: 'cadastro_sistema.nome', searchable: true, sortable: true},
                {key: 'nota_versao_versao', label: 'Versão', name: 'cadastro_nota_versao.versao', searchable: true, sortable: true},
                {key: 'nota_versao_titulo', label: 'Título', name: 'cadastro_nota_versao.titulo', searchable: true, sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ]
        },
    },
    inject: ['repositories'],
    methods: {
        handleDestroy(item) {
            const destroy = () => this.repositories.cadastro.notaVersao.destroy(item.nota_versao_id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDangerConfirmation('Confirmação', `Deseja realmente excluir a nota de versão ${item.nota_versao_versao}?`, destroy, this.handleError)
        },
    },
    mixins: [authorization, error, notification],
}
</script>